let signeLocalBufferedProducts = [];
let signeLocalNextUrl = null;
let signeLocalIsLoadingMore = false;

function isSearchResultsPage() {
  return /\/search\/?$/.test(window.location.pathname);
}
function getFollowingPageUrl(url) {
  if (!url) {
    return null;
  }

  const parsedUrl = new URL(url, window.location.origin);
  const currentPage = parseInt(
    parsedUrl.searchParams.get('page') || '1',
    10
  );

  parsedUrl.searchParams.set('page', currentPage + 1);

  return parsedUrl.pathname + parsedUrl.search;
}
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

function getCollectionStorageKey() {
  return `signe-local-collection-state:${window.location.pathname}${window.location.search}`;
}
function prepareInitialSearchResults() {
  if (!isSearchResultsPage()) {
    return;
  }

  const productList = document.querySelector('product-list.product-list');
  const currentCount = document.querySelector('[data-current-products-count]');

  if (!productList || !currentCount) {
    return;
  }

  const initialVisibleCount = 24;
  const items = Array.from(productList.children);

  if (items.length <= initialVisibleCount) {
    currentCount.textContent = items.length;
    updateProductsSeenLabel(items.length);
    return;
  }

  const overflowItems = items.slice(initialVisibleCount);

  overflowItems.forEach(function (item) {
    item.remove();
  });

  signeLocalBufferedProducts = overflowItems.concat(signeLocalBufferedProducts);
  currentCount.textContent = initialVisibleCount;
  updateProductsSeenLabel(initialVisibleCount);
}
function getViewedCount() {
  const currentCount = document.querySelector('[data-current-products-count]');
  return currentCount ? parseInt(currentCount.textContent, 10) || 0 : 0;
}

function getTotalCount() {
  const totalCountElement = document.querySelector('[data-total-products-count]');
  return totalCountElement ? parseInt(totalCountElement.textContent, 10) || null : null;
}

function saveCollectionState() {
  if (isSearchResultsPage()) {
    return;
  }

  const button = document.querySelector('[data-load-more-button]');
  const state = {
    scrollY: window.scrollY,
    viewedCount: getViewedCount(),
    nextUrl: signeLocalNextUrl || (button ? button.getAttribute('data-next-url') : null)
  };

  sessionStorage.setItem(getCollectionStorageKey(), JSON.stringify(state));
}

function updateProductsSeenLabel(viewedCount) {
  const seenLabel = document.querySelector('[data-products-seen-label]');
  const totalCount = getTotalCount();

  if (!seenLabel || !totalCount) {
    return;
  }

  const safeViewedCount = Math.min(viewedCount, totalCount);
  const isEnglish = window.location.pathname.startsWith('/en/');

  seenLabel.textContent = isEnglish
    ? `${safeViewedCount} products viewed out of ${totalCount}`
    : `${safeViewedCount} produits vus sur ${totalCount}`;
}

function showAllProductsSeenMessage(button) {
  if (button) {
    button.hidden = true;
  }

  const doneMessage = document.querySelector('[data-all-products-seen-message]');

  if (doneMessage) {
    doneMessage.hidden = false;
  }
}

async function loadMoreProducts(button, options = {}) {
  if (!button || signeLocalIsLoadingMore) {
    return 0;
  }

  const requestedLimit = options.limit || (isSearchResultsPage() ? 24 : 40);
  const currentProductList = document.querySelector('product-list.product-list');
  const currentCount = document.querySelector('[data-current-products-count]');
  const totalCount = getTotalCount();
  const currentViewedCount = getViewedCount();

  if (!currentProductList) {
    return 0;
  }

  const remainingProducts = totalCount ? Math.max(totalCount - currentViewedCount, 0) : requestedLimit;
  const productsPerClick = Math.min(requestedLimit, remainingProducts);

  if (productsPerClick <= 0) {
    showAllProductsSeenMessage(button);
    return 0;
  }

  signeLocalIsLoadingMore = true;

  const originalText = button.getAttribute('data-original-text') || button.textContent.trim();
  const loadingText = button.getAttribute('data-loading-text') || 'Chargement...';

  if (!options.silent) {
    button.disabled = true;
    button.textContent = loadingText;
  }

  function getProductKey(item) {
    const productLink = item.querySelector('a[href*="/products/"]');

    if (!productLink) {
      return item.id || item.outerHTML;
    }

    return productLink.pathname;
  }

  const existingProductKeys = new Set(
    Array.from(currentProductList.children).map(function (item) {
      return getProductKey(item);
    })
  );

  try {
    let productsToAdd = [];

    while (productsToAdd.length < productsPerClick) {
      if (signeLocalBufferedProducts.length > 0) {
        const item = signeLocalBufferedProducts.shift();
        const productKey = getProductKey(item);

        if (!existingProductKeys.has(productKey)) {
          existingProductKeys.add(productKey);
          productsToAdd.push(item);
        }

        continue;
      }

      const nextUrl = signeLocalNextUrl || button.getAttribute('data-next-url');

      if (!nextUrl) {
        break;
      }

      const response = await fetch(nextUrl);
      const text = await response.text();

      const parser = new DOMParser();
      const nextDocument = parser.parseFromString(text, 'text/html');

      const nextProductList = nextDocument.querySelector('product-list.product-list');

      if (!nextProductList) {
        if (isSearchResultsPage()) {
          console.warn(
          '[Signé Local] Fin de pagination de recherche atteinte :',
          nextUrl
        );

        signeLocalNextUrl = null;
        break;
  }

  window.location.href = nextUrl;
  return 0;
}

      signeLocalBufferedProducts = Array.from(nextProductList.querySelectorAll(':scope > *'));

      const nextButton = nextDocument.querySelector('[data-load-more-button]');
      signeLocalNextUrl = nextButton ? nextButton.getAttribute('data-next-url') : null;

      const productsAccountedFor =
      currentViewedCount +
      productsToAdd.length +
      signeLocalBufferedProducts.length;
    
      if (
  isSearchResultsPage() &&
  !signeLocalNextUrl &&
  totalCount &&
  productsAccountedFor < totalCount
      ) {
      signeLocalNextUrl = getFollowingPageUrl(nextUrl);
    }

      if (signeLocalBufferedProducts.length === 0 && !signeLocalNextUrl) {
        break;
      }
    }

    productsToAdd.forEach(function (item) {
      currentProductList.appendChild(item);
    });

    let viewedCount = null;

    if (currentCount) {
      const previousCount = parseInt(currentCount.textContent, 10) || 0;
      const newCount = previousCount + productsToAdd.length;

      viewedCount = totalCount ? Math.min(newCount, totalCount) : newCount;
      currentCount.textContent = viewedCount;

      updateProductsSeenLabel(viewedCount);
    }

    const allProductsSeen = totalCount && viewedCount >= totalCount;
    const hasMoreProducts = !allProductsSeen && (signeLocalBufferedProducts.length > 0 || signeLocalNextUrl);

    if (hasMoreProducts) {
      if (signeLocalNextUrl) {
        button.setAttribute('data-next-url', signeLocalNextUrl);
      }

      if (!options.silent) {
        button.disabled = false;
        button.textContent = originalText;
      }
    } else {
      button.removeAttribute('data-next-url');
      showAllProductsSeenMessage(button);
    }

    saveCollectionState();

    return productsToAdd.length;
  } catch (error) {
    console.error('Erreur Voir plus de produits:', error);

    const fallbackUrl = signeLocalNextUrl || button.getAttribute('data-next-url');

    if (fallbackUrl && !options.silent && !isSearchResultsPage()) {
      window.location.href = fallbackUrl;
    }

    return 0;
  } finally {
    signeLocalIsLoadingMore = false;
  }
}

async function restoreCollectionState() {
  if (isSearchResultsPage()) {
    sessionStorage.removeItem(getCollectionStorageKey());
    return;
  }

  const savedStateRaw = sessionStorage.getItem(getCollectionStorageKey());

  if (!savedStateRaw) {
    return;
  }

  let savedState;

  try {
    savedState = JSON.parse(savedStateRaw);
  } catch (error) {
    return;
  }

  const targetScrollY = savedState.scrollY || 0;

  // Premier repositionnement rapide, avant même de recharger les produits.
  window.scrollTo(0, targetScrollY);

  const button = document.querySelector('[data-load-more-button]');

  if (!button) {
    return;
  }

  const targetViewedCount = savedState.viewedCount || 0;

  while (getViewedCount() < targetViewedCount) {
    const addedCount = await loadMoreProducts(button, { silent: true });

    if (!addedCount) {
      break;
    }

    // Repositionnement pendant le chargement, pour éviter que la page reste trop longtemps en bas.
    window.scrollTo(0, targetScrollY);
  }

  // Derniers ajustements après que le navigateur a recalculé la hauteur de la page.
  requestAnimationFrame(function () {
    window.scrollTo(0, targetScrollY);

    setTimeout(function () {
      window.scrollTo(0, targetScrollY);
    }, 100);

    setTimeout(function () {
      window.scrollTo(0, targetScrollY);
    }, 300);
  });
}

document.addEventListener('click', async function (event) {
  const button = event.target.closest('[data-load-more-button]');

  if (!button) {
    return;
  }

  event.preventDefault();
  await loadMoreProducts(button);
});

document.addEventListener('click', function (event) {
  const productLink = event.target.closest('product-list a[href*="/products/"], .product-card a[href*="/products/"]');

  if (!productLink) {
    return;
  }

  saveCollectionState();
}, true);

window.addEventListener('pagehide', function () {
  if (document.querySelector('product-list.product-list')) {
    saveCollectionState();
  }
});

async function balanceInitialMobileProductCount() {
  const isMobile = window.matchMedia('(max-width: 699px)').matches;

  if (!isMobile) {
    return;
  }

  const button = document.querySelector('[data-load-more-button]');

  if (!button) {
    return;
  }

  const viewedCount = getViewedCount();

  if (viewedCount === 0 || viewedCount % 2 === 0) {
    return;
  }

  await loadMoreProducts(button, {
    silent: true,
    limit: 1
  });
}

function balanceCompactDesktopProductCount() {
  const isMobile = window.matchMedia('(max-width: 699px)').matches;

  if (isMobile) {
    return;
  }

  const isCompactDesktop =
    window.innerWidth <= 1280 &&
    window.innerHeight <= 720;

  if (!isCompactDesktop) {
    return;
  }

  const productList = document.querySelector('product-list.product-list');
  const currentCount = document.querySelector('[data-current-products-count]');

  if (!productList || !currentCount) {
    return;
  }

  const viewedCount = getViewedCount();

  if (viewedCount !== 47) {
    return;
  }

  const lastItem = productList.lastElementChild;

  if (!lastItem) {
    return;
  }

  lastItem.remove();
  signeLocalBufferedProducts.unshift(lastItem);

  currentCount.textContent = 46;
  updateProductsSeenLabel(46);

  saveCollectionState();
}

function runInitialProductBalancing() {
  setTimeout(function () {
    prepareInitialSearchResults();
    balanceCompactDesktopProductCount();
    balanceInitialMobileProductCount();
  }, 100);
}

window.addEventListener('pageshow', function (event) {
  if (!document.querySelector('product-list.product-list')) {
    return;
  }

  if (event.persisted) {
    runInitialProductBalancing();
    return;
  }

  restoreCollectionState().then(function () {
    runInitialProductBalancing();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('product-list.product-list')) {
    return;
  }

  runInitialProductBalancing();
});

function runProductCountBalancingWhenReady() {
  let attempts = 0;

  const interval = setInterval(function () {
    attempts += 1;

    const productList = document.querySelector('product-list.product-list');

    if (productList) {
      clearInterval(interval);
      runInitialProductBalancing();
      return;
    }

    if (attempts >= 20) {
      clearInterval(interval);
    }
  }, 100);
}

runProductCountBalancingWhenReady();